// 客户端请求
var userAgent = window.navigator.userAgent
var WebViewJavascriptBridge

// 判断设备信息
window.isIOS = function () {
  if (userAgent.indexOf('Mac OS X') > -1) {
    return true
  }
}
window.isAndroid = function () {
  if (userAgent.indexOf('Android') > -1) {
    return true
  }
}

window.isApp = function () {
  if (userAgent.includes('szd_SZGov')) {
    return true;
  } else {
    return false;
  }
}

if (isApp()) {
  if (isIOS()) {
    function setupWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback]; // 创建一个 WVJBCallbacks 全局属性数组，并将 callback 插入到数组中。
      var WVJBIframe = document.createElement('iframe'); // 创建一个 iframe 元素
      WVJBIframe.style.display = 'none'; // 不显示
      WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'; // 设置 iframe 的 src 属性
      document.documentElement.appendChild(WVJBIframe); // 把 iframe 添加到当前文导航上。
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    }

    // 这里主要是注册 OC 将要调用的 JS 方法。
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('getTokenSuccess', function (res) {
        window.getTokenSuccess(res)
      });
      bridge.registerHandler('getNewTokenSuccess', function (res) {
        window.getNewTokenSuccess(res)
      });
      bridge.registerHandler('getTokenRawSuccess', function (res) {
        window.getTokenRawSuccess(res)
      });
      bridge.registerHandler('getNewTokenRawSuccess', function (res) {
        window.getNewTokenRawSuccess(res)
      });
      bridge.registerHandler('h5PostResponse', function (res) {
        window.h5PostResponse(res)
      });
      bridge.registerHandler('h5GetResponse', function (res) {
        window.h5GetResponse(res)
      });
      bridge.registerHandler('loginsuccess', function (res) {
        window.loginsuccess(res)
      });
      bridge.registerHandler('realnamesuccess', function (res) {
        window.realnamesuccess(res)
      });
      bridge.registerHandler('scansuccess', function (res) {
        window.scansuccess(res)
      });
      bridge.registerHandler('doLocalsuccess', function (res) {
        window.doLocalsuccess(res)
      });
      bridge.registerHandler('getPosition', function (res) {
        window.getPosition(res)
      });
      bridge.registerHandler('doCarSuccess', function (res) {
        window.doCarSuccess(res)
      });
      bridge.registerHandler('scanSuccess', function (res) {
        window.scanSuccess(res)
      });
    });
  }
  // 注册JS调用原生方法
  window.getToken = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getToken', {
        getToken: 'getTokenSuccess'
      })
    } else {
      window.SzdUserInfoJsbridge && window.SzdUserInfoJsbridge.getToken('getTokenSuccess')
    }
  }

  window.getNewToken = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getNewToken', {
        getNewToken: 'getNewTokenSuccess'
      })
    } else {
      window.SzdUserInfoJsbridge && window.SzdUserInfoJsbridge.getNewToken('getNewTokenSuccess')
    }
  }
  window.getTokenRaw = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getTokenRaw', {
        getTokenRaw: 'getTokenRawSuccess'
      })
    } else {
      window.SzdUserInfoJsbridge && window.SzdUserInfoJsbridge.getTokenRaw('getTokenRawSuccess')
    }
  }

  window.getNewTokenRaw = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getNewTokenRaw', {
        getNewTokenRaw: 'getNewTokenRawSuccess'
      })
    } else {
      window.SzdUserInfoJsbridge && window.SzdUserInfoJsbridge.getNewTokenRaw('getNewTokenRawSuccess')
    }
  }
  // 异步函数，防止阻塞
  window.showServiceIntro = async function (pageParam) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('showServiceIntro', {
        showServiceIntro: pageParam
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.showServiceIntro(pageParam)
    }
  }

  window.showRightNavIntro = async function (pageParam) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('showRightNavIntro', {
        showRightNavIntro: pageParam
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.showRightNavIntro(pageParam)
    }
  }

  window.doRealNameAuth = function (realname) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('doRealNameAuth', {
        doRealNameAuth: realname
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.doRealNameAuth(realname)
    }
  }

  /*
    证照类型：
      1：居民身份证
      3：港澳居民来往内地通行证
      4：台湾居民来往内地通行证
      5：外国人永久居留身份证
      15：港澳台居民居住证（通行证、证件起始时间、证件结束时间必传）
  */
  window.doSelfFaceAuthGAT = function (scan, userRealIdNum = "", userRealName = "", type = "", nationId = "", passCardId = "", startTime = "", endTime = "") {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('doSelfFaceAuthGAT', {
        doSelfFaceAuthGAT: scan,
        cardNum: userRealIdNum,
        userName: userRealName,
        type,
        nationNumber: nationId,
        passCardid: passCardId,
        startTime,
        endTime
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.doSelfFaceAuthGAT(scan, userRealIdNum, userRealName, type, nationId, passCardId, startTime, endTime)
    }
  }
  window.doSelfFaceAuth = function (scan) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('doSelfFaceAuth', {
        doSelfFaceAuth: scan
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.doSelfFaceAuth(scan)
    }
  }
  window.doLocalLivenessInvalidate = function (scan) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('doLocalLivenessInvalidate', {
        doLocalLivenessInvalidate: scan
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.doLocalLivenessInvalidate(scan)
    }
  }
  window.nativeLogin = function (login) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('nativeLogin', {
        nativeLogin: login
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.nativeLogin(login)
    }
  }
  window.faceAuthFlag = function (callBack) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('faceAuthFlag', function (res) {
        callBack(res)
      })
    } else {
      window.CommonJsbridge && callBack(window.CommonJsbridge.faceAuthFlag())
    }
  }
  window.getUserInfo = function (callBack) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getUserInfo', function (res) {
        callBack(res)
      })
    } else {
      window.CommonJsbridge && callBack(window.CommonJsbridge.getUserInfo())
    }
  }
  window.nativeGetRquest = function (id, url) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('nativeGetRquest', {
        id: id,
        url: url
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.nativeGetRquest(id, url)
    }
  }
  window.nativePostRquest = function (id, url, params) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('nativePostRquest', {
        id: id,
        url: url,
        params: JSON.stringify(params)
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.nativePostRquest(id, url, JSON.stringify(params))
    }
  }
  window.nativePostJsonRequest = function (id, url, params) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('nativePostJsonRequest', {
        id: id,
        url: url,
        params: JSON.stringify(params)
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.nativePostJsonRequest(id, url, JSON.stringify(params))
    }
  }
  window.getNativeLocation = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('startLocate', {
        startLocate: 'getPosition'
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.startLocate('getPosition')
    }
  }

  window.startLocateSilently = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('startLocateSilently', {
        startLocate: 'getPosition'
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.startLocateSilently('getPosition')
    }
  }

  window.dail = function (phone) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('dail', {
        phone
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.dail(phone)
    }
  }
  window.call = function (phone) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('call', {
        phone
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.call(phone)
    }
  }

  window.openPage = function (pageRoute, pageParams) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('openPage', {
        pageRoute,
        pageParams
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.openPage(pageRoute, pageParams)
    }
  }
  window.openBrowser = function (url) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('openBrowser', {
        openBrowser: url
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.openBrowser(url)
    }
  }
  window.openPageWithPop = function (pageRoute, pageParams) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('openPageWithPop', {
        pageRoute,
        pageParams
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.openPageWithPop(pageRoute, pageParams)
    }
  }
  window.openNewsDetail = function (path, newsId, publishId, title) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('openNewsDetail', {
        path: path,
        newsId: newsId,
        publishId: publishId,
        title: title
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.openNewsDetail(path, newsId, publishId, title)
    }
  }
  window.hideTitleBar = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('hideTitleBar')
    } else {
      window.CommonJsbridge && window.CommonJsbridge.hideTitleBar()
    }
  }
  window.showTitleBar = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('showTitleBar')
    } else {
      window.CommonJsbridge && window.CommonJsbridge.showTitleBar()
    }
  }
  window.closeWindow = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('closeWindow')
    } else {
      window.CommonJsbridge && window.CommonJsbridge.closeWindow()
    }
  }
  window.clearAllWebviewCache = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('clearAllWebviewCache')
    } else {
      window.CommonJsbridge && window.CommonJsbridge.clearAllWebviewCache()
    }
  }
  window.toast = function (info) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('toast', info)
    } else {
      window.CommonJsbridge && window.CommonJsbridge.toast(info)
    }
  }
  window.showLoadingDialog = function (tips) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('showLoadingDialog', tips)
    } else {
      window.CommonJsbridge && window.CommonJsbridge.showLoadingDialog(tips)
    }
  }
  window.dismissLoadingDialog = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('dismissLoadingDialog')
    } else {
      window.CommonJsbridge && window.CommonJsbridge.dismissLoadingDialog()
    }
  }
  window.getCancelType = function (callBack) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getCancelType', function (res) {
        callBack(res)
      })
    } else {
      window.LogOffJsBridge && callBack(window.LogOffJsBridge.getCancelType())
    }
  }
  window.getCancelCause = function (callBack) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getCancelCause', function (res) {
        callBack(res)
      })
      // return WebViewJavascriptBridge.callHandler('getCancelCause')
    } else {
      window.LogOffJsBridge && callBack(window.LogOffJsBridge.getCancelCause())
    }
  }
  window.onLogOffSuccess = function () {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('onLogOffSuccess')
    } else {
      return window.LogOffJsBridge && window.LogOffJsBridge.onLogOffSuccess()
    }
  }
  window.share = function (title, content, iconUrl, pageUrl) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('share', {
        title: title,
        content: content,
        iconUrl: iconUrl,
        pageUrl: pageUrl
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.share(title, content, iconUrl, pageUrl)
    }
  }

  window.shareXJ = function (paramJson) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('shareXJ', paramJson)
    } else {
      window.CommonJsbridge && window.CommonJsbridge.shareXJ(JSON.stringify(paramJson))
    }
  }

  window.shareToWechat = function (title, content, iconUrl, pageUrl) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('shareToWechat', {
        title: title,
        content: content,
        iconUrl: iconUrl,
        pageUrl: pageUrl
      })
    } else {
      return window.CommonJsbridge && window.CommonJsbridge.shareToWechat(title, content, iconUrl, pageUrl)
    }
  }

  window.shareToWechatCircle = function (title, content, iconUrl, pageUrl) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('shareToWechatCircle', {
        title: title,
        content: content,
        iconUrl: iconUrl,
        pageUrl: pageUrl
      })
    } else {
      return window.CommonJsbridge && window.CommonJsbridge.shareToWechatCircle(title, content, iconUrl, pageUrl)
    }
  }

  window.shareToQQ = function (title, content, iconUrl, pageUrl) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('shareToQQ', {
        title: title,
        content: content,
        iconUrl: iconUrl,
        pageUrl: pageUrl
      })
    } else {
      return window.CommonJsbridge && window.CommonJsbridge.shareToQQ(title, content, iconUrl, pageUrl)
    }
  }

  window.saveFile = function (fileName, fileStringData) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('saveFile', {
        fileName: fileName,
        fileStringData: fileStringData
      })
    } else {
      return window.CommonJsbridge && window.CommonJsbridge.saveFile(fileName, fileName)
    }
  }

  window.saveFileByBase64 = function (fileName, fileBStringData) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('saveFileByBase64', {
        fileName: fileName,
        fileBStringData: fileBStringData
      })
    } else {
      return window.CommonJsbridge && window.CommonJsbridge.saveFileByBase64(fileName, fileBStringData)
    }
  }

  window.saveFileToGalleryByBase64 = function (fileName, fileBStringData) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('saveFileToGalleryByBase64', {
        fileName: fileName,
        fileBStringData: fileBStringData
      })
    } else {
      return window.CommonJsbridge && window.CommonJsbridge.saveFileToGalleryByBase64(fileName, fileBStringData)
    }
  }

  window.saveLocalData = function (paramJson) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('saveLocalData', paramJson)
    } else {
      window.CommonJsbridge && window.CommonJsbridge.saveLocalData(paramJson)
    }
  }

  window.getNativeBehaviorInfo = function (callBack) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getNativeBehaviorInfo', function (res) {
        callBack(res)
      })
    } else {
      return window.CommonJsbridge && callBack(window.CommonJsbridge.getNativeBehaviorInfo())
    }
  }

  window.getNativeStaticsPageInfo = function (callBack) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getNativeStaticsPageInfo', function (res) {
        callBack(res)
      })
    } else {
      return window.CommonJsbridge && callBack(window.CommonJsbridge.getNativeStaticsPageInfo())
    }
  }

  window.nativeBehaviorStatistics = function (info) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('nativeBehaviorStatistics', info)
    } else {
      window.CommonJsbridge && window.CommonJsbridge.nativeBehaviorStatistics(info)
    }
  }

  window.jumpToWXMiniProgram = function (miniAppId, miniAppUrl) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('jumpToWXMiniProgram', {
        miniAppId: miniAppId,
        miniAppUrl: miniAppUrl
      })
    } else {
      return window.CommonJsbridge && window.CommonJsbridge.jumpToWXMiniProgram(miniAppId, miniAppUrl)
    }
  }

  window.getNativeInfo = function (callBack) {
    if (isIOS()) {
      return WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('getNativeInfo', function (res) {
        callBack(res)
      })
    } else {
      return window.CommonJsbridge && callBack(window.CommonJsbridge.getNativeInfo())
    }
  }

  window.isAppInstalledByScheme = function (packagename, callBack) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('isAppInstalledByScheme', packagename, function (res) {
        callBack(res)
      })
    } else {
      window.CommonJsbridge && callBack(window.CommonJsbridge.isAppInstalledByScheme(packagename))
    }
  }

  window.jumpToOtherAppByScheme = function (packagename) {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('jumpToOtherAppByScheme', packagename)
    } else {
      window.CommonJsbridge && window.CommonJsbridge.jumpToOtherAppByScheme(packagename)
    }
  }

  window.doCarLicensePlateRecognition = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('doCarLicensePlateRecognition', {
        doCarLicensePlateRecognition: 'doCarSuccess'
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.doCarLicensePlateRecognition('doCarSuccess')
    }
  }

  window.openScanner = function () {
    if (isIOS()) {
      WebViewJavascriptBridge && WebViewJavascriptBridge.callHandler('openScanner', {
        openScanner: 'scanSuccess'
      })
    } else {
      window.CommonJsbridge && window.CommonJsbridge.openScanner('scanSuccess')
    }
  }

}

// 埋点公用方法
window.behavior = function (obj) {
  getNativeBehaviorInfo(res => {
    let info = Object.assign(obj, JSON.parse(res));
    nativeBehaviorStatistics(JSON.stringify(info));
  });

}

// 客户端响应

var resData = {}
// get请求
window.h5GetResponse = function (res) {
  handleData(res)
}
//post请求
window.h5PostResponse = function (res) {
  handleData(res)
}
window.handleData = function (res) {
  let json = res.indexOf('{') > -1 && JSON.parse(res)
  if (JSON.stringify(json.res).indexOf('{') === -1) {
    resData[json.callId] = json.res
    return
  }
  json.res = JSON.parse(json.res)
  resData[json.callId] = json.res
}
//获取最终数据
window.dispatch = function (request) {
  return new Promise(resolve => {
    Object.defineProperty(resData, request, {
      set: function (data) {
        resolve(data)
      }
    })
  })
}